<template>
    <Dropdown :title="dropdownTitle" ref="Dropdown">
        <div class="from-to-dates">
            <FormGroup :label="translate('labels.from')" class="mb-0">
                <DatePicker v-model="fromValue" :placeholder="translate('labels.from')" />
            </FormGroup>
            <FormGroup :label="translate('labels.to')" class="mb-0">
                <DatePicker v-model="toValue" :placeholder="translate('labels.to')" />
            </FormGroup>
        </div>
    </Dropdown>
</template>

<script>
import Dropdown from "./DropdownComponent.vue";
import DatePicker from "../../form/datePiker/DatePicker.vue";
import FormGroup from "../../../new/form/group/FormGroup.vue";
import DateFormatter from "../../../../services/DateFormatter"
export default  {
    name: "FromToDatesComponent",
    props: ['title', 'from', 'to'],
    emits: ['update:from', 'update:to'],
    data() {
        return {
            DateFormatter
        }
    },
    computed: {
        fromValue: {
            get() {
                return this.getValue(this.from)
            },
            set(newValue) {
                const value = newValue ? new Date(newValue) : null;

                if (value > this.toValue) {
                    this.setValue('from', value)
                    this.setValue('to', null)
                } else {
                    this.setValue('from', value)
                }
            }
        },
        toValue: {
            get() {
                return this.getValue(this.to)
            },
            set(newValue) {
                const value = newValue ? new Date(newValue) : null;

                if (value < this.fromValue) {
                    this.setValue('to', value)
                    this.setValue('from', null)
                } else {
                    this.setValue('to', value)
                }
            }
        },
        dropdownTitle() {
            let title = translate('table.titles.created_at');

            if (this.from || this.to) {
                title += `:`
            }

            if (this.from) {
                title += ` ${translate('labels.from')} ${this.formatDate(this.from)}`
            }

            if (this.to) {
                title += ` ${translate('labels.to')} ${this.formatDate(this.to)}`
            }

            return title;
        }
    },
    methods: {
        getValue(value) {
            return value ? new Date(value) : null
        },
        setValue(key, value) {
            let newValue = value ?
                `${String(value.getFullYear())}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
                : null;

            this.$emit(`update:${key}`, newValue)
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return `${day}.${month}.${year}`;
        }
    },
    components: {
        Dropdown,
        DatePicker,
        FormGroup
    }
}
</script>

<style scoped>
.from-to-dates{
    padding: 13px 10px;
    display: flex;
    column-gap: 10px;
}
</style>
